import React from "react";
import { FaMagnifyingGlass, FaFilePen, FaCode, FaGear, FaRocket, FaChevronRight } from "react-icons/fa6";
import { Container, GradientButton, H3_SIZE, SectionHeading, tones } from "./ui";

const steps = [
  { icon: FaMagnifyingGlass, tone: "blue", title: "Discover", text: "We understand your business, audience, goals, and project requirements." },
  { icon: FaFilePen, tone: "violet", title: "Plan & Design", text: "We define the project structure, user journeys, wireframes, and visual direction." },
  { icon: FaCode, tone: "green", title: "Develop", text: "We turn approved designs into responsive, functional digital products." },
  { icon: FaGear, tone: "orange", title: "Test & Refine", text: "We check usability, compatibility, performance, and functionality before launch." },
  { icon: FaRocket, tone: "violet", title: "Launch & Support", text: "We help launch your solution and provide agreed ongoing support." },
];

const HowWeWork = () => (
  <section className="relative overflow-hidden bg-gradient-to-b from-white via-[#F7F8FF] to-white py-[20px] lg:py-[20px]">
    <Container>
      <SectionHeading badge="How we work" lined title="From First Conversation to" highlight="Successful Launch." />
      <div className="mx-auto mt-[14px] h-px w-16 bg-slate-300" />

      <div className="relative mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
        {/* dashed connector line (desktop) */}
        <div className="pointer-events-none absolute left-[10%] right-[10%] top-[48px] hidden border-t-2 border-dashed border-violet-200 lg:block" />
        {steps.map((s, i) => {
          const t = tones[s.tone];
          return (
            <div key={s.title} className="relative flex flex-col items-center ">
              <span className={`relative z-10 inline-flex h-[86px] w-[86px] items-center justify-center rounded-full ${t.soft} ring-8 ring-white`}>
                <span className={`inline-flex h-[60px] w-[60px] items-center justify-center rounded-full bg-white text-[24px] shadow-card ${t.text}`}>
                  <s.icon />
                </span>
              </span>
              {i < steps.length - 1 && (
                <span className="absolute -right-[22px] top-[36px] z-10 hidden h-6 w-6 items-center justify-center rounded-full bg-white text-[10px] text-slate-500 shadow-card lg:inline-flex">
                  <FaChevronRight />
                </span>
              )}
              <span className={`mt-[12px] h-2.5 w-2.5 rounded-full ${t.dot}`} />
              <span className="h-6 w-px bg-slate-200" />
              <div className="w-full flex-1 rounded-2xl bg-white p-[20px] shadow-card ring-1 ring-slate-100">
                <span className={`inline-block rounded-lg px-2.5 py-1 text-[14px] font-bold ${t.soft} ${t.text}`}>
                  {String(i + 1).padStart(2, "0")}.
                </span>
                <h3 className={`mt-[12px] font-bold text-ink ${H3_SIZE}`}>{s.title}</h3>
                <p className="mt-2 text-[13px] leading-relaxed text-slate-500">{s.text}</p>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-[40px] text-center">
        <GradientButton href="/contact-us">Discuss Your Project</GradientButton>
      </div>
    </Container>
  </section>
);

export default HowWeWork;
